import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n/i18n';
import router from './router/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import store from './store'
import axios from "axios";
import './assets/css/global.css';
import './assets/css/globalLess.less';
import LazySlideCaptcha from 'lazy-slide-captcha'
import 'lazy-slide-captcha/dist/lazy-slide-captcha.css';
import throttle from './assets/js/directive';
import VueMeta from 'vue-meta'
 


Vue.use(VueMeta)

Vue.use(LazySlideCaptcha).use(throttle);

// Vue.directive('throttle',{
//   inserted:function(el,binding){
//     let time = {};
//     el.addEventListener('click',()=>{
//         if(time){
//             clearTimeout()
//         }
//         time = setTimeout(()=>{
//             binding.value()
//         },2000)
//     })
//   }
// })

// Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  // store,
  i18n,
  axios,
  render: h => h(App)
}).$mount('#app')